export const dataTablaA2026 = [
  {
    titulo: "ITE OIC TRANSP 03-2026 ",
    archivo: "ITE-OIC-TRANSP-AC-003-2026.pdf", // o .xlsx si el documento es Excel
  },
];